import { render, staticRenderFns } from "./SettingsKebab.vue?vue&type=template&id=902cd1b8"
import script from "./SettingsKebab.vue?vue&type=script&lang=js"
export * from "./SettingsKebab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports